import React, { useContext, useState } from "react";
import UserContext from "../context/UserContext";
import { SERVER_IP, ud, jwt } from "../Server";
import Swal from "sweetalert2";
import axios from "axios";
import { CloseIcon } from "../assets/Icons";

export default function FAQAdd(props) {
  const { parent_id } = props;
  const context = useContext(UserContext);
  const { updateddata, setUpdateddata } = context;

  const [inputdata, setInputdata] = useState([{ title: "", description: "" }]);
  const onChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputdata];
    list[index][name] = value;
    setInputdata(list);
  };

  const removeInput = (index) => {
    const list = [...inputdata];
    list.splice(index, 1);
    setInputdata(list);
  };

  const addInput = () => {
    setInputdata([...inputdata, { title: "", description: "" }]);
  };

  const clickHandler = async (e) => {
    e.preventDefault();
    // Add api call
    var data = { parent_id, layers: inputdata };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    const result = await axios.post(`${SERVER_IP}/userfaq/create/layer`, data, {
      withCredentials: true,
      headers: headers,
    });
    // Empty input data
    setInputdata([{ title: "", description: "" }]);
    if (result.data.error === false) {
      updateddata ? setUpdateddata(false) : setUpdateddata(true);
      document.getElementById(`addModal${parent_id}`).click();
      Swal.fire({
        title: "Success",
        text: result.msg,
        icon: "success",
        confirmButtonText: "Ok",
      });
    } else {
      document.getElementById(`addModal${parent_id}`).click();
      Swal.fire({
        title: "Error",
        text: result.msg,
        icon: "error",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <>
      <div className="modal-dialog modal-lg" role="document" key={parent_id}>
        <div className="modal-content">
          <div className="modal-header bg-light">
            <h5 className="modal-title" id="addModalLabel">
              FAQ Add
            </h5>
            <button id={`addModal${parent_id}`} type="button" className="close-s" data-dismiss="modal">
              <CloseIcon />{" "}
            </button>

            {/* <button
              data-dismiss="modal"
              className="close-s"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Close"
            >
              <CloseIcon />
            </button> */}
          </div>

          <div className="container py-4 border bg-white">
            <div className="row">
              <form className="col-sm-12" id="appendArea">
                {inputdata.map((singleService, index) => {
                  return (
                    <div className="card mb-3" key={index}>
                      <div className="card-body">
                        <div className="form-group">
                          <label>Title </label>
                          <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Enter your question"
                            name="title"
                            value={singleService.title}
                            onChange={(e) => onChange(e, index)}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label>Description</label>
                          <textarea
                            className="form-control"
                            placeholder="Enter your answer..."
                            rows="3"
                            name="description"
                            value={singleService.description}
                            onChange={(e) => onChange(e, index)}
                            required
                          ></textarea>
                        </div>

                        {inputdata.length !== 1 && (
                          <div className="text-right mt-2">
                            <button type="button" className="btn btn-sm btn-primary" onClick={() => removeInput(index)}>
                              Remove
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
                <div className="addBefore px-3">
                  <button type="submit" className="btn btn-primary mr-4" onClick={clickHandler}>
                    Add
                  </button>
                  <button type="button" className="btn btn-primary float-right" onClick={addInput}>
                    Add More
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
